import React, { useEffect, useState } from "react";
import { DownloadFile } from "../utility/functions/firebase";
import { useDispatch, useSelector } from "react-redux";
import { selectPrefix, selectWidth } from "../utility/Redux/profile";
import { toProperCase } from "../utility/component/format";
import { FormatNumber2 } from "../utility/functions/formatNumber";
import HandleIndexedDB from "../Test/handleIndexDb";
import "./animat.css";
import { fastMovingMovieItem, openItemTitle } from "../utility/constant";
import { getCurrency } from "./common";

const ItemBox = ({
  box,
  onClick,
  index,
  imgCard,
  mobileWidth,
  customerDetails,
}) => {
  const prefix = useSelector(selectPrefix);
  const icode = box.ICODE;
  const path = `retailx/items/${prefix.replace(/_.+_/, "_") + icode}`;
  const [img, setImg] = useState("");
  const width = useSelector(selectWidth);
  const isWholeSaleCustomer =
    customerDetails?.RATE_TYPE === "whole_sale" ? true : false;
  const sale_price = box.SALE_PRICE;
  const fireToken = localStorage.getItem("fire");

  useEffect(() => {
    if (box.IMAGE_1) {
      setImg(box.IMAGE_1);
      return;
    }
    if (!fireToken) {
      if (width > 600) {
        const isImgAvailval = imgCard.filter((o) => o.ICODE === box.ICODE);
        if (!img && navigator.onLine && !isImgAvailval[0]) {
          DownloadFile(path)
            .then((e) => {
              if (!e.includes("FirebaseError")) {
                const urlParams = new URLSearchParams(new URL(e).search);
                const token = urlParams.get("token");
                localStorage.setItem("fire", token);

                setImg(e);
              } else {
                setImg("");
              }
            })
            .catch((e) => {
              setImg("");
            });
        } else {
          if (imgCard[0]) {
            const i = imgCard.filter((o) => o.ICODE === box.ICODE);
            if (i[0]) {
              setImg(i[0]?.image);
            }
          }
        }
      }
    } else {
      const path = `https://firebasestorage.googleapis.com/v0/b/retailx-126e1.appspot.com/o/retailx%2Fitems%2F${
        prefix.replace(/_.+_/, "_") + box.ICODE
      }?alt=media&token=${fireToken}`;
      setImg(path);
      // DownloadFile(
      //   `retailx/items/${prefix.replace(/_.+_/, "_")}${box.ICODE}`
      // ).then((d) => {
      //   console.log(d);
      //   if (!d.includes("FirebaseError")) {
      //     setImg(d);
      //   } else {
      //     setImg("");
      //   }
      // });
    }
  }, [box]);
  // ${
  //         box.ITEMNAME === openItemTitle
  //           ? "bg-[#dae74a] "
  //           : box.SECTION_NAME === fastMovingMovieItem
  //           ? "bg-[#f7b03e] "
  //           : "bg-[#f5eb82]  hover:shadow-lg"
  //       }
  return (
    <button
      onClick={() => onClick(box)}
      className={`
        w-full p-1  rounded-lg transition-all duration-200 
        flex items-start 
      
         ${
           box.ITEMNAME === openItemTitle
             ? "bg-[#dae74a] "
             : box.SECTION_NAME === fastMovingMovieItem
             ? "bg-[#dad7ce] "
             : "bg-[#eae7df]  hover:shadow-lg"
         }
      `}
    >
      {width > 600 && img && (
        <div
          className={`w-16 h-16 rounded-lg overflow-hidden  ${
            box.ITEMNAME === openItemTitle
              ? "bg-[#c8d444] "
              : box.SECTION_NAME === fastMovingMovieItem
              ? "bg-[#dad7ce] "
              : "bg-[#dfddd9]"
          } flex-shrink-0`}
        >
          {img && (
            <img
              alt=""
              src={img}
              className="w-full h-full object-cover"
              onError={() => setImg("")}
            />
          )}
        </div>
      )}

      <div className="flex-1 min-w-0 ml-1 pr-2 ">
        <div className="flex justify-between items-start">
          <div className=" text-gray-900  text-start">
            {toProperCase(box.ITEMNAME)}
            <div className="text-[10px] text-gray-800">
              {box.PACKING} - {box.UNIT}
            </div>
          </div>
          <span
            className={`text-[12px]   ${
              box.ITEMNAME === openItemTitle
                ? "text-gray-800"
                : box.SECTION_NAME === fastMovingMovieItem
                ? "text-gray-800"
                : "text-gray-500"
            } `}
            style={{
              fontStyle: "italic",
            }}
          >
            {box.ICODE}
          </span>
        </div>

        <div className="mt-1 flex items-center ">
          <span
            className={`
              w-2 h-2 rounded-full mr-1
              ${
                sale_price > 0
                  ? box.BAL_STOCK > 0
                    ? "bg-green"
                    : "bg-red-400"
                  : "bg-gray-300"
              }
            `}
          />

          {sale_price > 0 && (
            <span className=" text-gray-900">
              {getCurrency()}
              {FormatNumber2(sale_price)}
            </span>
          )}
        </div>
      </div>
    </button>
  );
};

export default ItemBox;
